import React from 'react';
import { HeaderActions, Logo } from '@x5-react-uikit/dialog-widgets';
import { Box } from '@mui/material';
import { NavLink } from 'react-router-dom';

import Profile from '../Profile';
import Support from '../Support';

const Header = () => {
  return (
    <Box
      height="56px"
      bgcolor="#fff"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      // paddingLeft="24px"
      // paddingRight="21px"
      width="100%"
    >
      <NavLink to="/">
        <Logo logoName="targeting" />
      </NavLink>
      <HeaderActions>
        <Box mr="24px" />
        <Support />
        <Profile />
      </HeaderActions>
    </Box>
  );
};

export default Header;
